import axios from 'axios';
import {loadFromSessionStorage, StorageKey} from '../storage/SessionStorage';

const HTTP = axios.create({baseURL: '/api'});
HTTP.interceptors.request.use((config) => {
    const jwt = loadFromSessionStorage(StorageKey.jwt);

    if (jwt) {
        config.headers.authorization = 'Bearer ' + jwt;
    }

    return config;
});

export default HTTP;
